<script setup lang="ts">
    import { Button } from '@/components/ui/button';
    import { Minus } from 'lucide-vue-next';
    import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogTrigger,
    } from '@/components/ui/alert-dialog';
    import { router } from '@inertiajs/vue3';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';

    const props = defineProps<{
        companyId: number;
    }>();

    const { t } = useI18n();

    const deactivateBankConnection = () => {
        router.post(
            route('v2.bank.deactivate-connection', props.companyId),
            {},
            {
                preserveScroll: true,
                onSuccess: () => {
                    toast.success(t('viia.deactivate.deactivate_bank_connection_success'));
                },
                onError: (error) => {
                    toast.error(t('viia.deactivate.deactive_bank_connection_failed'));
                },
            },
        );
    };
</script>

<template>
    <AlertDialog>
        <AlertDialogTrigger as-child>
            <Button
                variant="ghost_destructive"
                size="xs"
                width="narrow"
            >
                {{ $t('viia.deactivate.deactivate_bank_connection') }}
                <Minus class="text-destructive" />
            </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>{{
                    $t('viia.deactivate.js.deactive_bank_connection_title')
                }}</AlertDialogTitle>
                <AlertDialogDescription>{{
                    $t('viia.deactivate.js.deactive_bank_connection_confirm')
                }}</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel>{{ $t('viia.deactivate.js.no') }}</AlertDialogCancel>
                <AlertDialogAction @click="deactivateBankConnection">{{
                    $t('viia.deactivate.js.yes')
                }}</AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
</template>
